import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import store from "../../../../redux";
import CCheckbox from '@/components/CForm/CCheckbox'
import CRadio from '@/components/CForm/CRadio'
import { setReload } from "@/redux/common/action";
import _ from 'lodash'
import { tableData} from './data'
import './index.scss'
import {savaScore} from "@/servers/storeManageApi";

import { specialaddlistHanndler,specialadddetailHanndler } from "@/servers/goodsManageApi";
import { getStoreCategoryList } from "@/servers/commonApi";
import {withRouter} from "react-router-dom";
import {Button, message, Modal,Select} from 'antd'
import {selectPicDetail} from "../../../../servers/menu";
const { Option} = Select

@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.addHandler = this.addHandler.bind(this);
    this.editHandler = this.editHandler.bind(this);
    this.deleteHandler = this.deleteHandler.bind(this);
    this.modalOk = this.modalOk.bind(this);
    this.modalCancel = this.modalCancel.bind(this);
    this.searchHandler = this.searchHandler.bind(this)
    this.resetHandler = this.resetHandler.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onChangelevel = this.onChangelevel.bind(this)
    this.onChangetj = this.onChangetj.bind(this)
    this.downloads = this.downloads.bind(this)
    this.handlePreview = this.handlePreview.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    page: tableData.tPage,
    loading: true,
    level:0,
    modal: {
      title: '删除数据',
      visible: false,
    },
    title2:'',
    deleteid:'',
    annual: '',
    levelid: '',
    ownerlist:[],
    options:[],
    detaildata:[],
    number:0
  };


  searchHandler(){
    this.getListData('seconds')
  }

  onChange(data){
    this.setState({
      annual:data
    },()=>{
      this.getListData('seconds')
    })
  }

  onChangelevel(data){
    this.setState({
      levelid:data
    })
  }

  resetHandler(){
    this.setState({
      annual:'',
      levelid: ''
    },()=>{
      this.getListData()
    })
  }

  modalCancel(){
    this.setState({
      modal: {...this.state.modal, visible: false},
      deleteid:''
    })
  }

  modalOk(){
    // const params = {
    //   id: this.state.deleteid
    // }
    // expertdelete(params).then(res=>{
    //   if (res.statecode === 0) {
    //     message.success('删除成功');
    //     this.modalCancel()
    //     this.getListData()
    //   } else {
    //     message.error('删除失败');
    //   }
    // })
  }

  // 获取用户列表数据
  getListData(data = ''){
    this.setState({
      loading: true
    });
    console.log(this.state.annual);
    const params = {
      levelid:this.state.levelid,
      annual:this.state.annual
    }
    specialaddlistHanndler(params).then(res=>{
      if (res.statecode === 0) {
        const arr = []
        res.records[0].levellist.forEach(item=>{
          item.value = item.id
        })
        res.records[0].annuallist.forEach(item=>{
          let obj = {}
          obj.name = item
          obj.value = item
          arr.push(obj)

        })
        const number = []
        res.records[0].scorelist.forEach(item=>{
          if (item.recommend == '是') {
            number.push(item)
          }
        })
        this.setState({
          dataSource: res.records[0].scorelist,
          ownerlist: arr,
          options: res.records[0].levellist,
          number:res.records[0].maxnum,
          loading:false
        });
        // if (data !== 'seconds'){
        //   this.setState({
        //     annual:arr[0].value
        //   });
        // }
      }
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  /*新增*/
  addHandler(){
    this.props.history.push({
      pathname: '/informationDeclaration/addspecialist',
      search: '?type=new'
    })
  }

  // 编辑当前行
  editHandler(data){
    sessionStorage.setItem('specialistEdit', JSON.stringify(data))
    this.props.history.push({
      pathname: '/informationDeclaration/addspecialist',
      search: `?type=edit&id=${data.id}`
    })
  }

  deleteHandler(data){
    const params =
        {
          id:data.id
        }
    specialadddetailHanndler(params).then(res=>{
      if (res.statecode === 0) {
        this.setState({
          detaildata:res.records,
          title2:data.project,
          modal: {...this.state.modal, visible: true},
        })
      }
    })
    // this.setState({
    //   modal: {...this.state.modal, visible: true},
    //   deleteid:data.id
    // })
  }

  onChangetj(value,data){
    let r = '0'
    if (value.length>0) {
      r = value.join(',')
    }
    const params = {
      score:r,
      id:data.id
    }
    savaScore([params]).then(res=>{
      if (res.statecode === 0) {
        message.success('修改成功');
        this.modalCancel()
        this.getListData()
      } else {
        message.error('修改失败');
      }
    })
    const d = this.state.dataSource
    d.forEach(item=>{
      if (item.id === data.id) {
        item.recommend = r
      }
    })
    this.setState({
      dataSource:d
    })
  }

  computedData(data){
    const str = data.replaceAll('\n', '</br>')
    return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
  }

  createMarkup(str) {
    return {__html: str}
  }

  async handlePreview(file){
    const params = {
      fileid: file.fileid
    }
    let timer = null
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].filepreviewurl !== '' && res.records[0].filepreviewurl !== null) {
        const type = res.records[0].filename.split('.')[res.records[0].filename.split('.').length - 1]
        clearTimeout(timer)
        window.open(res.records[0].filepreviewurl, '_blank')
      } else {
        timer = setTimeout(()=>{
          this.handlePreview(file)
        },1)
      }
    })
  }

  downloads(file){
    const params = {
      fileid: file.fileid
    }
    let timer = null
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].fileurl !== '' && res.records[0].fileurl !== null) {
        clearTimeout(timer)
        window.location.href = res.records[0].fileurl
      } else {
        timer = setTimeout(()=>{
          this.handlePreview(file)
        },1)
      }
    })
  }

  componentWillMount(){

  }

  componentDidMount(){
    this.getListData();
  }

  render(){
    return (
        <div className='user-manage-list'>
          <div className='flex filter-wrap'>
            <div className='flex filter-left'>
              <div>年份：</div>
              <Select
                  placeholder='请选择评估年度'
                  onChange={this.onChange}
                  style={{width:'160px'}}
                  value={this.state.annual}
              >
                {
                  this.state.ownerlist.map((item, index)=>{
                    return <Option key={index} value={item.value}>{item.name}</Option>
                  })
                }
              </Select>
              <CRadio value={this.state.levelid}
                      options={this.state.options}
                      onChange={this.onChangelevel}
              />
              <CButton type='primary' onClick={this.searchHandler}>查询</CButton>
              <CButton type='primary' onClick={this.resetHandler}>重置</CButton>
            </div>
          </div>
          <h3 style={{marginTop:'20px',color:'red'}}>
            允许推荐加分博物馆个数：{this.state.number}
          </h3>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource} onTableChange={this.onTableChange}>
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='operate1'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CCheckbox value={record.recommend==='是'?'1':''} onChange={(e)=>{this.onChangetj(e,record)}} options={[{value:'1',id:'1',name:'推荐',lable:'推荐'}]}>推荐</CCheckbox>
                    </div>
                )} />
            <div
                slot='operate'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.deleteHandler(record)}>查看</CButton>
                    </div>
                )} />
          </CTable>
          <Modal
              visible={this.state.modal.visible}
              onOk={this.modalOk}
              onCancel={this.modalCancel}
              footer={null}
              width={500}
          >
            <div className='detail-container' id="top" >
              <div>
                <h4 style={{marginBottom:'20px'}}>{this.state.detaildata.length>0?this.state.detaildata[0].museumname+'-'+this.state.title2:''}</h4>
                {this.state.detaildata.length>0?
                  this.state.detaildata[0].scoredetaillist.map((item,index)=>{
                      return (<div style={{display:'flex',borderBottom:'1px solid #bebebe'}}>
                        {
                          item.map(item2=>{
                            return (
                                <div style={{flex:1,textAlign:'center',marginBottom:'10px',alignItems:'center'}}>{item2}</div>
                            )
                          })
                        }
                      </div>)
                  }):''
                }
              </div>
              {this.state.detaildata.map((item,index)=>{
                return (
                    <div className="detail-item" style={{filter:'none'}}>
                      <div className='detail-title'>
                        <span>{item.name}</span>
                      </div>
                      <div className='detail-content'>
                        {this.computedData(decodeURIComponent(item.fillin))}
                      </div>
                      <ul className='uploadlistScore' style={{width:'500px'}}>
                        {
                          item.annexlist.length>0?
                              item.annexlist.map((item1,index1)=>{
                                return <li>
                                  <span>{index1+1}.{item1.filename}</span>
                                  <div>
                                    <span className="textbtn" onClick={()=>{this.downloads(item1)}}>下载</span>
                                    <span className="textbtn" onClick={()=>{this.handlePreview(item1)}}>预览</span>
                                  </div>
                                </li>
                              }):''
                        }
                      </ul>
                    </div>
                )
              })}
            </div>
          </Modal>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
